// Mirrors part_finder_attribute.type on the backend.
export enum AttributeType {
  COLOUR = 'colour',
  NUMBER_RANGE = 'number_range',
  VALUES = 'values',
}
